import React from 'react';
import Container from '../../Basic/Container/Container.mjs';
import Navigation from '../../Templates/Navigation/Navigation.mjs';
import Hero from '../../UIElements/Hero/Hero.mjs';
import TopStories from '../../UIElements/TopStories/TopStories.mjs';

const HomePage = ({ navigationProps, heroProps, topStoriesProps }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Navigation, Object.assign({}, navigationProps)),
        React.createElement(Hero, Object.assign({}, heroProps)),
        React.createElement(Container, { padding: { default: 0, sm: '0 1rem', md: '0 3.75rem' }, margin: { default: '0 auto', sm: '2.5rem auto' } },
            React.createElement(TopStories, Object.assign({}, topStoriesProps)))));
};

export { HomePage as default };
//# sourceMappingURL=HomePage.mjs.map
